import { Product } from '../../../services/product/product-data'
import { getOptimizedImageExtension } from '../../../utils/image-extensions'
import { getPriceData } from './price-info'

export type ProductJsonLD = {
  '@context': string
  '@type': string
  sku?: string
  '@id'?: string
  name?: string
  offers: {
    '@type': string
    url?: string
    priceCurrency?: string
    price?: number
    availability: string
  }
  description?: string
  brand: {
    '@type': string
    name: string
  }
  image?: string
  gtin?: string
}

export const generateProductJsonLD = (
  productData: Product | undefined,
  pageUrl: string | undefined
): ProductJsonLD => {
  const { currentPrice } = getPriceData(productData?.price)

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    sku: productData?.globalArticleCode,
    '@id': pageUrl,
    name: productData?.globalArticleName,
    offers: {
      '@type': 'Offer',
      url: pageUrl,
      priceCurrency: productData?.price?.priceCurrency,
      price: currentPrice,
      availability: 'https://schema.org/InStock'
    },
    description: productData?.productLongDescription,
    brand: {
      '@type': 'Thing',
      name: productData?.brand ?? ''
    },
    image: getOptimizedImageExtension(
      productData?.assets?.[0]?.assetFullUrl ?? ''
    ),
    gtin: productData?.gtin
  }
}
